"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/message/style/css");

var _message2 = _interopRequireDefault(require("antd/es/message"));

var _react = _interopRequireWildcard(require("react"));

var _tabs = _interopRequireDefault(require("antd/lib/tabs"));

var _reactRedux = require("react-redux");

var _appointments = require("../../../redux/appointments/appointments.types");

var selectors = _interopRequireWildcard(require("../../../redux/selectors"));

require("./appointmentLandingPage.scss");

var _api = require("../../../redux/api/api.types");

var _typesafeActions = require("typesafe-actions");

var _reactRouterDom = require("react-router-dom");

var _participants = require("../../../redux/participants/participants.types");

var _AvailabilityCalendar = _interopRequireDefault(require("../../../components/appointment/AvailabilityCalendar"));

var _AppointmentCalendar = _interopRequireDefault(require("../../../components/appointment/AppointmentCalendar"));

var _reselect = require("reselect");

var _availability = require("../../../redux/availabilty/availability.types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class AppointmentLandingPage extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      events: new Map()
    };

    this.handleTabChange = activeKey => {
      const {
        history,
        studyId
      } = this.props;
      history.push(`/study/${studyId}/appointments/${activeKey}`);
    };
  }

  componentDidMount() {
    this.props.getParticipantsByStudy(this.props.studyId);
  }

  componentDidUpdate(prevProps) {
    // Error and success handling
    const {
      createAppointmentStatus,
      updateAppointmentStatus,
      deleteAppointmentStatus,
      createAvailabilityStatus,
      deleteAvailabilityStatus,
      clearLoadStatus
    } = this.props;

    if (!prevProps.createAppointmentStatus.isError && createAppointmentStatus.isError) {
      _message2.default.error(`Error: ${createAppointmentStatus.errorMessage}`);

      clearLoadStatus((0, _typesafeActions.getType)(_appointments.createAppointmentAsync.failure));
    } else if (!prevProps.updateAppointmentStatus.isError && updateAppointmentStatus.isError) {
      _message2.default.error('Error while updating appointment.');

      clearLoadStatus((0, _typesafeActions.getType)(_appointments.updateAppointmentAsync.failure));
    } else if (!prevProps.deleteAppointmentStatus.isError && deleteAppointmentStatus.isError) {
      _message2.default.error('Error while deleting appointment.');

      clearLoadStatus((0, _typesafeActions.getType)(_appointments.deleteAppointmentAsync.failure));
    } else if (!prevProps.createAppointmentStatus.isSuccess && createAppointmentStatus.isSuccess) {
      _message2.default.success('Appointment successfully created.');

      clearLoadStatus((0, _typesafeActions.getType)(_appointments.createAppointmentAsync.success));
    } else if (!prevProps.updateAppointmentStatus.isSuccess && updateAppointmentStatus.isSuccess) {
      _message2.default.success('Appointment successfully updated.');

      clearLoadStatus((0, _typesafeActions.getType)(_appointments.updateAppointmentAsync.success));
    } else if (!prevProps.deleteAppointmentStatus.isSuccess && deleteAppointmentStatus.isSuccess) {
      _message2.default.success('Appointment successfully deleted.');

      clearLoadStatus((0, _typesafeActions.getType)(_appointments.deleteAppointmentAsync.success));
    } else if (!prevProps.deleteAvailabilityStatus.isSuccess && deleteAvailabilityStatus.isSuccess) {
      _message2.default.success('Availability successfully deleted.');

      clearLoadStatus((0, _typesafeActions.getType)(_availability.deleteAvailabilityAsync.success));
    } else if (!prevProps.deleteAvailabilityStatus.isError && deleteAvailabilityStatus.isError) {
      _message2.default.error('Error while deleting availability.');

      clearLoadStatus((0, _typesafeActions.getType)(_availability.deleteAvailabilityAsync.failure));
    } else if (!prevProps.createAvailabilityStatus.isSuccess && createAvailabilityStatus.isSuccess) {
      _message2.default.success('Availability successfully created.');

      clearLoadStatus((0, _typesafeActions.getType)(_availability.createAvailabilityAsync.success));
    } else if (!prevProps.createAvailabilityStatus.isError && createAvailabilityStatus.isError) {
      _message2.default.error(`Error while creating availability.`);

      clearLoadStatus((0, _typesafeActions.getType)(_availability.createAvailabilityAsync.failure));
    }
  }

  render() {
    const {
      showAvailability,
      appointmentSubpage
    } = this.props;

    if (showAvailability) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "appointment-landing"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "appointment-main"
      }, /*#__PURE__*/_react.default.createElement(_tabs.default, {
        defaultActiveKey: appointmentSubpage,
        onChange: this.handleTabChange
      }, /*#__PURE__*/_react.default.createElement(_tabs.default.TabPane, {
        tab: "Availability",
        key: "availability"
      }, /*#__PURE__*/_react.default.createElement(_AvailabilityCalendar.default, null)), /*#__PURE__*/_react.default.createElement(_tabs.default.TabPane, {
        tab: "Appointments",
        key: "appointments"
      }, /*#__PURE__*/_react.default.createElement(_AppointmentCalendar.default, null)))));
    } else {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "appointment-landing"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "appointment-main"
      }, /*#__PURE__*/_react.default.createElement(_AppointmentCalendar.default, null)));
    }
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  studyId: selectors.getRequestedStudyId,
  showAvailability: selectors.getAppointmentAvailabilityFeatureEnabled,
  createAppointmentStatus: selectors.createAppointmentStatus,
  updateAppointmentStatus: selectors.updateAppointmentStatus,
  deleteAppointmentStatus: selectors.deleteAppointmentStatus,
  appointmentSubpage: selectors.getRequestedAppointmentTab,
  createAvailabilityStatus: selectors.createAvailabilityStatus,
  deleteAvailabilityStatus: selectors.deleteAvailabilityStatus
});

const mapDispatchToProps = dispatch => {
  return {
    clearLoadStatus: type => dispatch((0, _api.clearStatus)(type)),
    getParticipantsByStudy: studyId => dispatch(_participants.getParticipantsByStudyAsync.request(studyId))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouterDom.withRouter)(AppointmentLandingPage));

exports.default = _default;